import React, { Fragment, useEffect, useState } from 'react'
import { getGlobalCookie, setGlobalCookie } from '../../utils'
import { imgStoragePath } from '../../constants'
import { appConfig } from '../../config'
import { Grid } from '@mui/material'

const bannerEnv = {
  development: 'dev',
  staging: 'qa',
  uat: 'uat',
  production: 'prod',
}[process.env.REACT_APP_ENV];

export default function DeploymentBanner() {
  const [deploymentFlag, setDeploymentFlag] = useState(false)
  const [bannerData, setBannerData] = useState(null)

  useEffect(() => {
    getInfo()
    //URL will be called in every 6 hours 
    const interval = setInterval(getInfo, (6 * 60 * 60 * 1000))
    return clearInterval(interval)
  }, [])

  const getInfo = () => {
    fetch(`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/maintenance_banner/${bannerEnv}/info.json?timestamp=${new Date().getTime()}`)
      .then(res => res.json())
      .then(resp => {
        const dismissed = JSON.parse(getGlobalCookie('showBanner') || '{}')
        if (resp?.for_lease_reavmp && (resp?.id !== dismissed?.lease_reavmp || !dismissed?.lease_reavmp)) {
          setDeploymentFlag(resp?.for_lease_reavmp)
          setBannerData(resp)
        }
      })
      .catch(() => { })
  }

  const getClientData = () => {
    let oldCookie = JSON.parse(getGlobalCookie('showBanner'))
    let leaseRevampCookie = { lease_reavmp: bannerData?.id}
    setGlobalCookie('showBanner', JSON.stringify({ ...oldCookie, ...leaseRevampCookie }), 3);
  }

  return (
    <Fragment>
      {deploymentFlag && bannerData  ?
        <Grid container spacing={1} style={{display:'block', position:'relative', top:'-5px', cursor:'default'}} >
          <Grid item md="12">
            <p className="deployment-info">
              <span>
                {bannerData?.message}
              </span>
              <span >
                <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
              </span>
            </p>
          </Grid>
        </Grid> : null
      }
    </Fragment>
  )
}
